import { Button } from "@/shared/components/ui/button";
import { Card, CardContent } from "@/shared/components/ui/card";
import { useIntegrationConsent } from "@/shared/integrations/integration-consent";

export function AnalyticsConsentBanner() {
  const { analytics, grantAnalytics, denyAnalytics } = useIntegrationConsent();
  if (analytics !== "unknown") return null;

  return (
    // The dock is only a layout column from lg up; below that Copilot is a sheet that overlays the banner.
    <div className="fixed inset-x-0 bottom-0 z-50 p-4 pb-[max(1rem,env(safe-area-inset-bottom))] lg:right-[var(--copilot-dock-inset,0px)]">
      <Card
        role="region"
        aria-label="Analytics choices"
        className="mx-auto max-w-3xl gap-0 py-0 shadow-lg"
      >
        <CardContent className="flex flex-col gap-4 px-5 py-4 sm:flex-row sm:items-center sm:justify-between">
          <div className="max-w-2xl">
            <p className="text-sm font-medium text-text-primary">Help improve Pulsewise</p>
            <p className="mt-1 text-sm text-text-secondary">
              Allow privacy-safe product analytics so we can understand which screens and setup
              steps are useful. We do not record sessions, form text, payroll data, or private
              feedback.
            </p>
          </div>
          <div className="flex shrink-0 gap-2">
            <Button type="button" variant="outline" className="min-h-11" onClick={denyAnalytics}>
              Reject
            </Button>
            <Button type="button" className="min-h-11" onClick={grantAnalytics}>
              Accept analytics
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
